import React, { useState } from 'react';
import './CommonStyles.css';
import { Info, Download, ChevronDown, List, Plus, Search, Trash2, Edit3, Printer, FileSpreadsheet, FileText } from 'lucide-react';

const ReceiptPrinters = () => {
    const [showAddModal, setShowAddModal] = useState(false);
    const [showExportDropdown, setShowExportDropdown] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');

    const [printers, setPrinters] = useState([
        { id: 1, name: 'Main Kitchen Printer', type: 'Network', ip: '192.168.1.100', port: '9100' },
        { id: 2, name: 'Counter Receipt Printer', type: 'USB', ip: '--', port: '--' }
    ]);

    const renderAddModal = () => (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
            <div style={{ background: '#fff', borderRadius: '8px', width: '700px', maxWidth: '95vw', overflow: 'hidden', boxShadow: '0 10px 25px rgba(0,0,0,0.2)' }}>
                {/* Modal Header */}
                <div style={{ padding: '1.25rem 1.5rem', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3 style={{ margin: 0, fontSize: '1.25rem', color: '#1e293b', fontWeight: '600' }}>Add new printer</h3>
                    <button onClick={() => setShowAddModal(false)} style={{ background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', fontSize: '1.5rem', lineHeight: '1' }}>&times;</button>
                </div>

                {/* Modal Body */}
                <div style={{ padding: '1.5rem' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
                        <div style={{ gridColumn: 'span 2' }}>
                            <label style={{ display: 'block', fontWeight: '700', color: '#1e293b', marginBottom: '0.4rem' }}>Printer Name:*</label>
                            <input type="text" placeholder="Printer Name" style={{ width: '100%', padding: '0.6rem 0.8rem', border: '1px solid #cbd5e1', borderRadius: '6px' }} />
                            <small style={{ color: '#64748b', display: 'block', marginTop: '0.25rem' }}>Short Descriptive Name to recognize printer</small>
                        </div>

                        <div>
                            <label style={{ display: 'block', fontWeight: '700', color: '#1e293b', marginBottom: '0.4rem' }}>Connection Type:*</label>
                            <div style={{ position: 'relative' }}>
                                <select style={{ width: '100%', padding: '0.6rem 0.8rem', border: '1px solid #cbd5e1', borderRadius: '6px', background: '#fff', appearance: 'none' }}>
                                    <option>Network</option>
                                    <option>USB</option>
                                    <option>Parallel</option>
                                </select>
                                <ChevronDown size={16} style={{ position: 'absolute', right: '1rem', top: '50%', transform: 'translateY(-50%)', color: '#64748b', pointerEvents: 'none' }} />
                            </div>
                        </div>

                        <div>
                            <label style={{ display: 'block', fontWeight: '700', color: '#1e293b', marginBottom: '0.4rem' }}>Capability Profile:*</label>
                            <div style={{ position: 'relative' }}>
                                <select style={{ width: '100%', padding: '0.6rem 0.8rem', border: '1px solid #cbd5e1', borderRadius: '6px', background: '#fff', appearance: 'none' }}>
                                    <option>Default</option>
                                    <option>Star</option>
                                    <option>Espon</option>
                                </select>
                                <ChevronDown size={16} style={{ position: 'absolute', right: '1rem', top: '50%', transform: 'translateY(-50%)', color: '#64748b', pointerEvents: 'none' }} />
                            </div>
                        </div>

                        <div>
                            <label style={{ display: 'block', fontWeight: '700', color: '#1e293b', marginBottom: '0.4rem' }}>Characters per line:*</label>
                            <input type="number" defaultValue="42" style={{ width: '100%', padding: '0.6rem 0.8rem', border: '1px solid #cbd5e1', borderRadius: '6px' }} />
                        </div>

                        <div>
                            <label style={{ display: 'block', fontWeight: '700', color: '#1e293b', marginBottom: '0.4rem' }}>IP Address:*</label>
                            <input type="text" placeholder="IP Address" style={{ width: '100%', padding: '0.6rem 0.8rem', border: '1px solid #cbd5e1', borderRadius: '6px' }} />
                            <small style={{ color: '#64748b', display: 'block', marginTop: '0.25rem' }}>IP address for connecting to the printer</small>
                        </div>

                        <div>
                            <label style={{ display: 'block', fontWeight: '700', color: '#1e293b', marginBottom: '0.4rem' }}>Port:*</label>
                            <input type="number" defaultValue="9100" style={{ width: '100%', padding: '0.6rem 0.8rem', border: '1px solid #cbd5e1', borderRadius: '6px' }} />
                            <small style={{ color: '#64748b', display: 'block', marginTop: '0.25rem' }}>Most printer works on port 9100</small>
                        </div>
                    </div>
                </div>

                {/* Modal Footer */}
                <div style={{ padding: '1rem 1.5rem', borderTop: 'none', display: 'flex', justifyContent: 'center', gap: '0.5rem', paddingBottom: '2rem' }}>
                    <button style={{ background: '#7c3aed', color: 'white', border: 'none', borderRadius: '6px', padding: '0.6rem 2rem', fontWeight: '600', cursor: 'pointer', minWidth: '100px' }}>
                        Save
                    </button>
                    <button onClick={() => setShowAddModal(false)} style={{ background: '#334155', color: 'white', border: 'none', borderRadius: '6px', padding: '0.6rem 2rem', fontWeight: '600', cursor: 'pointer', minWidth: '100px' }}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );

    return (
        <div style={{ padding: '0', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <div style={{ background: '#fff', borderRadius: '8px', border: '1px solid #e2e8f0', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
                {/* Header Row */}
                <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #e2e8f0', padding: '0 1rem' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '1rem 0' }}>
                        <Printer size={20} style={{ color: '#3b82f6' }} />
                        <h3 style={{ margin: 0, fontSize: '1rem', color: '#1e293b', fontWeight: '700' }}>All your receipt printers</h3>
                    </div>

                    <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <div style={{ position: 'relative' }}>
                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                style={{ padding: '0.4rem 0.8rem', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '0.85rem', width: '180px', outline: 'none' }}
                            />
                        </div>
                    </div>
                </div>

                <div style={{ padding: '1.5rem' }}>
                    {/* Controls Row */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
                        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                            <span style={{ fontSize: '0.9rem', color: '#64748b' }}>Show</span>
                            <select style={{ padding: '0.3rem 0.5rem', border: '1px solid #e2e8f0', borderRadius: '4px', fontSize: '0.85rem' }}>
                                <option>25</option>
                                <option>50</option>
                                <option>100</option>
                            </select>
                            <span style={{ fontSize: '0.9rem', color: '#64748b' }}>entries</span>
                        </div>

                        <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                            <div style={{ position: 'relative' }}>
                                <button
                                    onClick={() => setShowExportDropdown(!showExportDropdown)}
                                    style={{ background: '#fff', color: '#64748b', border: '1px solid #e2e8f0', padding: '0.5rem 1rem', borderRadius: '6px', display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.875rem', fontWeight: '600', cursor: 'pointer' }}
                                >
                                    <Download size={16} /> Export <ChevronDown size={14} />
                                </button>
                                {showExportDropdown && (
                                    <div style={{ position: 'absolute', top: '100%', right: 0, marginTop: '0.5rem', background: '#fff', border: '1px solid #e2e8f0', borderRadius: '6px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)', zIndex: 50, minWidth: '160px', padding: '0.5rem 0' }}>
                                        <button style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', width: '100%', padding: '0.6rem 1rem', border: 'none', background: 'none', textAlign: 'left', fontSize: '0.85rem', color: '#334155', cursor: 'pointer' }}>
                                            <FileSpreadsheet size={16} color="#10b981" /> Export CSV
                                        </button>
                                        <button style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', width: '100%', padding: '0.6rem 1rem', border: 'none', background: 'none', textAlign: 'left', fontSize: '0.85rem', color: '#334155', cursor: 'pointer' }}>
                                            <Printer size={16} color="#3b82f6" /> Print
                                        </button>
                                        <button style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', width: '100%', padding: '0.6rem 1rem', border: 'none', background: 'none', textAlign: 'left', fontSize: '0.85rem', color: '#334155', cursor: 'pointer' }}>
                                            <FileText size={16} color="#ef4444" /> Export PDF
                                        </button>
                                    </div>
                                )}
                            </div>
                            <button onClick={() => setShowAddModal(true)} style={{ background: '#3b82f6', color: 'white', border: 'none', borderRadius: '6px', padding: '0.5rem 1.25rem', fontWeight: '600', fontSize: '0.875rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
                                <Plus size={18} /> Add
                            </button>
                        </div>
                    </div>

                    {/* Table View */}
                    <div style={{ overflowX: 'auto', background: '#fff', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '0.9rem' }}>
                            <thead>
                                <tr style={{ background: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
                                    {['Printer Name', 'Connection Type', 'IP Address', 'Port', 'Action'].map((header, idx) => (
                                        <th key={idx} style={{ padding: '1rem', color: '#1e293b', fontWeight: '700', whiteSpace: 'nowrap' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                                                {header}
                                                {header !== 'Action' && <Info size={14} style={{ color: '#06b6d4' }} />}
                                            </div>
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {printers.map((p) => (
                                    <tr key={p.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                        <td style={{ padding: '1rem' }}><strong>{p.name}</strong></td>
                                        <td style={{ padding: '1rem' }}>{p.type}</td>
                                        <td style={{ padding: '1rem' }}>{p.ip}</td>
                                        <td style={{ padding: '1rem' }}>{p.port}</td>
                                        <td style={{ padding: '0.75rem 1rem' }}>
                                            <div style={{ display: 'flex', gap: '0.5rem' }}>
                                                <button style={{ background: '#fff', color: '#8b5cf6', border: '1px solid #8b5cf6', padding: '0.3rem 0.6rem', borderRadius: '4px', fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.3rem', cursor: 'pointer' }}>
                                                    <Edit3 size={12} /> Edit
                                                </button>
                                                <button style={{ background: '#fff', color: '#ef4444', border: '1px solid #ef4444', padding: '0.3rem 0.6rem', borderRadius: '4px', fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.3rem', cursor: 'pointer' }}>
                                                    <Trash2 size={12} /> Delete
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {showAddModal && renderAddModal()}
            </div>
        </div>
    );
};

export default ReceiptPrinters;
